import { render, staticRenderFns } from "./BasePageHeading.vue?vue&type=template&id=b6457cee&"
import script from "./BasePageHeading.vue?vue&type=script&lang=js&"
export * from "./BasePageHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports